import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { useEffect, useState } from "react";
import { useStudio } from "@/hooks/useStudio";
import { useConfiguratorContext } from "@/hooks/configurator/configurator-context";

const environments = ["studio", "water"] as const;

export function EnvironmentSwitcher() {
  const studio = useStudio();
  const configurator = useConfiguratorContext();

  const [environment, setEnvironment] =
    useState<(typeof environments)[number]>("studio");

  const handleChangeEnvironment = (value: (typeof environments)[number]) => {
    setEnvironment(value);

    (window as any).environment = value;

    switch (value) {
      case "studio":
        studio.viewer.setEnvironment("poly_haven_studio");
        studio.viewer.setBackgroundType("color");
        studio.viewer.setBackgroundColor("#fff");
        studio.viewer.setWaterEnabled(false);

        break;
      // case "colorful":
      //   studio.viewer.setEnvironment("poly_haven_studio");
      //   studio.viewer.setBackgroundType("color");
      //   studio.viewer.setBackgroundColor("#fff");
      //   studio.viewer.setWaterEnabled(false);
      //   break;
      case "water":
        studio.viewer.setEnvironment("venice_sunset");
        studio.viewer.setBackgroundBlurriness(0.5);
        studio.viewer.setBackgroundType("environment");
        studio.viewer.setBackgroundColor("#000");
        studio.viewer.setWaterEnabled(true);
        studio.viewer.setWaterYOffset(0.35);
        studio.viewer.setWaterWaveSpeed(0.1);
        studio.viewer.setWaterDistortionScale(0.1);
        studio.viewer.setWaterSize(2);
        break;
    }
  };

  useEffect(() => {
    if (!studio.loaded) return;
    handleChangeEnvironment(environment);
  }, [studio.loaded]);

  return (
    <Select value={environment} onValueChange={handleChangeEnvironment}>
      <SelectTrigger>
        <SelectValue placeholder="Select an environment" />
      </SelectTrigger>
      <SelectContent>
        {environments.map((env) => (
          <SelectItem key={env} value={env}>
            {env.charAt(0).toUpperCase() + env.slice(1)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
